module.exports = __webpack_public_path__ + "img/b3.24721c66.png";